module.exports = {"id":"189712","name":"Kevin Strootman","rating":"83","photo":"./data/images/photos/1/189712.png","club":{"name":"AS Rome","logo":"./data/images/clubs/ASRome.png"},"positions":["MC","MDC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KevinStrootman0.json
// module id = 2354
// module chunks = 0